import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  padding: 15px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.systemColors.red};
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const Message = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  font-weight: 500;
`;
